const styles = theme => ({
  OrganizationSignUPContainer: {
    backgroundSize: "cover",
    marginTop: "0px",
    padding: theme.spacing(10),
    minHeight: "100vh",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0),
      alignItems: "flex-start",
      minHeight: "0px"
    }
  },
  informationContainer: {
    width: "800px",
    height: "auto",
    backgroundImage: "none",
    backgroundColor: "#f8f8ff",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "100%",
      marginTop: "0px"
    }
  },
  logoContainer: {
    height: "100px",
    margin: theme.spacing(5)
  },
  contentContainer: {
    marginLeft: theme.spacing(8),
    marginRight: theme.spacing(8),
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(3),
      marginRight: theme.spacing(3)
    }
  },
  title: {
    color: theme.palette.primary.default
  },
  subtitle: {
    color: theme.palette.primary.default
  },
  buttonsContainer: {
    paddingRight: theme.spacing(3),
    width: "100%",
    padding: `${theme.spacing(2)}px 0`
  },
  cancelButtonText: {
    color: theme.palette.primary.default
  },
  buttonNext: {
    marginLeft: theme.spacing(2),
    backgroundColor: theme.palette.primary.default,
    "&:hover": {
      backgroundColor: theme.palette.primary.default
    },
    color: ["#fff", "!important"]
  },
  buttonProgress: {
    marginLeft: ["1px", "!important"]
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/pages/OrganizationSignUp/styles.js